import {
    CaretRightOutlined,
    RightOutlined,
    MinusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Steps,
    Button,
    message,
    Form,
    Input,
    Image,
    Carousel,
    Card,
    Divider,
    Select,
    DatePicker,
    Radio,
    Checkbox,
    Space,
    Avatar,
    AutoComplete,
} from "antd";
import React, { useEffect, useState } from "react";
import commonService from "../../api/common.service";
import timeSlotService from "../../api/time.slot.service";
import { HIGH_PERFORMANCE_TAG, JCP_PROGRAM_TAG, PF_TAG, SUCCESS_STATUS } from "../../utility/Constants";
const { Option } = Select;

function TimeSlotEnrollment(props) {
   
  //  const [timeSlotList, setTimeSlotList] = useState([props.timeSlotListData]);
    const [dayList, setDayList] = useState([]);
    const [isAlldaysChecked, setIsAlldaysChecked] = useState(false);

   

    useEffect(() => {
        commonService.dayList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setDayList(res.data.response_data);
            }
        });
    }, []);

    // useEffect(() => {
    //     const data = {
    //         formdata: { programme_id: props.programmeID, programme_group_id : props.programmeGroupID },
    //     };
    //     timeSlotService.timeSlotByProgrammeAndGroup(data).then((res) => {
    //         if (res.data.response_status === SUCCESS_STATUS) {
    //             setTimeSlotList(res.data.response_data);
    //         }
    //     });
    // }, []);

    const onAllDaysChange = (e) => {
        setIsAlldaysChecked(false);
        props.form.setFieldsValue({ day_slot: [] });
        if(e.target.checked && e.target.checked == true) {
            let obj = [];
            dayList.map((e) => {
                const time_slot = {
                  day_id: e.day_id,
                  //time_slot_id: e.time_slot,
                };
                obj.push(time_slot);
            });
            props.form.setFieldsValue({ day_slot: obj });
            setIsAlldaysChecked(true);
        }
    };

  return (
    <div>

        {
            props.mode == "ADD" && (props.module == PF_TAG || props.module == HIGH_PERFORMANCE_TAG || props.module == JCP_PROGRAM_TAG) ? <>
            <Checkbox onChange={onAllDaysChange}>All Days</Checkbox>
            </> : <></>
        }
        
        <Form.List name="day_slot">
                                    {(fields, { add, remove }) => (
                                        <>
                                            
                                            {fields.map(({ key, name, ...restField }) => (
                                                <Space
                                                    key={key}
                                                    style={{
                                                        display: "flex",
                                                        marginBottom: 8,
                                                    }}
                                                    align="baseline"
                                                >
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, "day_id"]}
                                                        rules={[
                                                            {
                                                                required: props?.isDayRequired != undefined ? props?.isDayRequired : true,
                                                                message: "Day",
                                                            },
                                                        ]}
                                                        hidden={props?.isDayRequired != undefined ? !props?.isDayRequired : false}
                                                    >
                                                        <Select
                                                            className="text-left"
                                                            defaultValue="Select"
                                                            style={{ width: "200px" }}
                                                            allowClear={true}
                                                            disabled={isAlldaysChecked ? true : false}
                                                        >
                                                            {dayList.length > 0
                                                                ? dayList.map((day_list) => (
                                                                    <Option
                                                                        key={day_list.day_id}
                                                                        value={day_list.day_id}
                                                                    >
                                                                        {day_list.day_name}
                                                                    </Option>
                                                                ))
                                                                : ""}
                                                        </Select>
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name, "time_slot_id"]}
                                                        rules={[
                                                            {
                                                                required: props?.isDayTimeRequired != undefined ? props?.isDayTimeRequired : true,
                                                                message: "Time",
                                                            },
                                                        ]}
                                                        hidden={props?.isDayTimeRequired != undefined ? !props?.isDayTimeRequired : false}
                                                        allowClear={true}
                                                    >
                                                        <Select
                                                            className="text-left"
                                                            defaultValue="Select"
                                                            style={{ width: "250px" }}
                                                        >
                                                            {props.timeSlotListData.length > 0
                                                                ? props.timeSlotListData.map((time_slot) => (
                                                                    <Option
                                                                        key={time_slot.time_slot_id}
                                                                        value={time_slot.time_slot_id}
                                                                    >
                                                                        {time_slot.time_slot}
                                                                    </Option>
                                                                ))
                                                                : ""}
                                                        </Select>
                                                    </Form.Item>
                                                    <>
                                                        {
                                                            isAlldaysChecked ? <></> : <>
                                                                    {
                                                                        props.mode == "ADD" || props.mode == "UPDATE" ? (<MinusCircleOutlined onClick={() => remove(name)} />) : ''   
                                                                    }
                                                            
                                                            </>
                                                        }
                                                    </>             
                                                    
                                                    

                                                </Space>
                                            ))}
                                            <Form.Item hidden={isAlldaysChecked}>
                                                {
                                                    props.mode == "ADD" || props.mode == "UPDATE" ? (
                                                        <Button
                                                  
                                                    className="custom-button-green"
                                                    onClick={() => {
                                                        add();
                                                      }}
                                                    icon={<PlusOutlined />}
                                                >
                                                    Add Day Slot
                                                </Button>
                                                    ) : ''
                                                }
                                                
                                            </Form.Item>
                                        </>
                                    )}
                                </Form.List>
    </div>
  )
}

export default TimeSlotEnrollment